/**
 * UI language store (zh / en), persisted in localStorage.
 */

import { create } from 'zustand';

export type Lang = 'zh' | 'en';

export const LANG_STORAGE_KEY = 'bsp_language';

const isLang = (value: unknown): value is Lang => value === 'zh' || value === 'en';

const readInitialLang = (): Lang => {
  try {
    const saved = window.localStorage.getItem(LANG_STORAGE_KEY);
    return isLang(saved) ? saved : 'zh';
  } catch {
    return 'zh';
  }
};

interface LanguageState {
  lang: Lang;
  setLang: (lang: Lang) => void;
}

export const useLanguageStore = create<LanguageState>()((set) => ({
  lang: readInitialLang(),

  setLang: (lang) => {
    try {
      window.localStorage.setItem(LANG_STORAGE_KEY, lang);
    } catch {
      // localStorage may be unavailable (private mode / quota); keep in-memory only
    }
    set({ lang });
  },
}));
